export default [
  {
    $el: 'div',
    children: [
      {
        $formkit: 'text',
        name: 'email',
        'validation-label': 'Email',
        validation: 'required|email',
        placeholder: 'Enter your email address',
      },
    ],
  },
];
